const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;
const SplitText = window.SplitText;

gsap.registerPlugin(ScrollTrigger, SplitText);

import { lenisScroll } from './modules/lenis.js';
import { anchorScroll } from './modules/anchorScroll.js';
import { parallaxImage } from './modules/parallaxImage.js';
import { accordion } from './modules/accordion.js';
import { cardAnimate } from './modules/cardAnimate.js';
import { headingUpdate } from './modules/headingUpdate.js';
import { mobileNav } from './modules/mobileNav.js';
import { galleryMarquee } from './modules/galleryMarquee.js';
import { textReveal } from './modules/textReveal.js';
import { footerGradient } from './modules/footerGradient.js';
import { heroSlider } from './modules/heroSlider.js';
import { teamOverlay } from './modules/teamOverlay.js';
import { projectSlider } from './modules/projectSlider.js';
import { dropdownMenu } from './modules/dropdownMenu.js';
import { formSwitcher } from './modules/formSwitcher.js';
import { initializeDatepicker } from './modules/datePicker.js';


// import { sectionFadeIn } from './modules/sectionFadeIn.js';

// import { header } from './modules/header.js';

lenisScroll();
anchorScroll();
parallaxImage();
accordion();
cardAnimate();
headingUpdate();
mobileNav();
galleryMarquee();
textReveal();
footerGradient();
heroSlider();
teamOverlay();
projectSlider();
dropdownMenu();
formSwitcher();
initializeDatepicker()


// sectionFadeIn();

// header();